import { ChangeDetectionStrategy, Component, HostAttributeToken, inject } from "@angular/core";

@Component({
    selector: "lg-render-indicator",
    template: "‹{{ _count }}›",
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: "lg-render-indicator"
    },
    styles: []
})
export class LgRenderIndicatorComponent {
    static _renderCounts: Record<string, number> = {};

    readonly group = inject(new HostAttributeToken("group"), { optional: true }) || "global";
    readonly _count: number;

    constructor() {
        if (LgRenderIndicatorComponent._renderCounts[this.group] === undefined) {
            LgRenderIndicatorComponent._renderCounts[this.group] = 0;
        }
        this._count = LgRenderIndicatorComponent._renderCounts[this.group]++;
    }
}
